import { Flex } from "@chakra-ui/layout";
import { Progress, Text } from "@chakra-ui/react";
import { Modal } from "antd";

interface ModalUploadProgressProps {
  uploading: Record<string, number>;
  isIndeterminate?: boolean;
}

function ModalUploadProgress({
  uploading,
  isIndeterminate = true,
}: ModalUploadProgressProps) {
  return (
    <Modal
      centered
      visible={!!Object.keys(uploading).length}
      footer={null}
      destroyOnClose
      closable={false}
      width={"600px"}
      bodyStyle={{
        overflow: "auto",
      }}
    >
      <Text mb={8} as="h3" fontWeight="bold" fontSize={18}>
        Progresso dos uploads dos arquivos
      </Text>
      {Object.keys(uploading).map((key, i) => (
        <Flex flexDir="column" mb={6} key={i}>
          <Text mb={2} fontSize={14} fontWeight="medium">
            {key}
          </Text>
          <Progress
            isIndeterminate={isIndeterminate}
            hasStripe
            value={uploading[key]}
            height="28px"
            colorScheme="cyan"
          />
        </Flex>
      ))}
    </Modal>
  );
}

export default ModalUploadProgress;
